import React, { useEffect, useRef, useState } from "react";
import "../WorkFlow/WorkFlow.css";
import cardImg1 from "../../assets/ServiceImages/NewImages/CardImg1.jpg";
import cardImg2 from "../../assets/ServiceImages/NewImages/CardImg2.jpg";
import cardImg3 from "../../assets/ServiceImages/NewImages/CardImg3.jpg";
import cardImg4 from "../../assets/ServiceImages/NewImages/CardImg4.jpg";

import Banner from "../../assets/ServiceImages/NewImages/Banner.jpg";
import cardImg5 from "../../assets/ServiceImages/NewImages/CardImg5.jpg";
import cardImg6 from "../../assets/ServiceImages/NewImages/CardImg6.jpg";
import cardImg7 from "../../assets/ServiceImages/NewImages/CardImg7.jpg";

import Safety from "../../assets/Safety.svg";
import Weather from "../../assets/weather.svg";
import HighQuality from "../../assets/HighQuality.svg";

import gsap from "gsap";
import Aos from "aos";
import "aos/dist/aos.css";
import "../Service/ServiceSlider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const WorkFlow = () => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const slideRefs = useRef([]);
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  const settings = {
    infinite: true,
    slidesToShow: 2,
    speed: 500,
    focusOnSelect: true,
    arrows: false,
    dots: false,
    beforeChange: (current, next) => {
      // Check if we are transitioning from the last to the first slide
      if (next === 0 && current === slideRefs.current.length - 1) {
        sliderRef.current.slickGoTo(0, true); // Instant reset to 0 without blinking
      }
    },
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          arrows: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const [hover, setHover] = useState(false);
  useEffect(() => {
    gsap.fromTo(
      slideRefs.current[0],
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }
    );
  }, []);

  useEffect(() => {
    const handleWheel = (e) => {
      if (hover) {
        e.preventDefault();
        if (e.deltaY < 0) {
          sliderRef.current.slickPrev();
        } else {
          sliderRef.current.slickNext();
        }
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => window.removeEventListener("wheel", handleWheel);
  }, [hover]);
  const cardsData = [
    {
      id: 1,
      imgSrc: Weather,
      title: "High Weather Protection",
      description:
        "Provides superior defense against rain, wind, and sun, ensuring durability and comfort.",
    },
    {
      id: 2,
      imgSrc: Safety,
      title: "Safety & Trusted Reliability",
      description:
        "Engineered for dependable safety and consistent performance in various environments.",
    },
    {
      id: 3,
      imgSrc: HighQuality,
      title: "High Quality Materials",
      description:
        "Crafted from premium materials for exceptional strength, longevity, and reliability.",
    },
  ];

  const items = [
    {
      id: 1,
      img: cardImg7,
      heading: "Smart Pergola",
      description:
        "Sleek, automated pergola with motorized louvers and sensors for stylish, year-round outdoor comfort.",
      route: "/smart-pergola/",
    },
    {
      id: 2,
      img: cardImg2,
      heading: "Pergolas",
      description:
        "Elevate your outdoor space with bespoke pergolas crafted with premium materials for durability and timeless style.",
      route: "/pergolas/",
    },
    {
      id: 3,
      img: cardImg1,
      heading: "Glass Rooms",
      description:
        "Enjoy nature’s beauty with custom glass rooms, offering stunning views and seamless integration with your surroundings.",
      route: "/glass-rooms/",
    },

    {
      id: 4,
      img: cardImg3,
      heading: "Bar & BBQ Counters",
      description:
        "Transform your backyard with custom-designed Bar & BBQ Counters, made with high-quality aluminum for durability and style.",
      route: "/bbq-area/",
    },
    {
      id: 5,
      img: cardImg4,
      heading: "Car Parking Pergolas",
      description:
        "Protect vehicles from the elements while adding elegance with expertly designed, durable car parking pergolas.",
      route: "/car-parking-shades/",
    },
    {
      id: 6,
      img: cardImg5,
      heading: "Doors & Fences",
      description:
        "Premium aluminum doors and windows, crafted with precision for durability, style, and aesthetic appeal in any space.",
      route: "/aluminium-doors/",
    },
    {
      id: 7,
      img: cardImg6,
      heading: "CNC Cut Panels",
      description:
        "Intricately designed CNC cut panels for gardens and lounges, adding elegance to your outdoor space with advanced technology.",
      route: "/cnc-panel-cutter/",
    },
  ];

  return (
    <>
      <div className="customslidersection">
        <div
          style={{
            position: "relative",
            maxHeight: "365px",
            backgroundImage: `url(${Banner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "black",
              opacity: "0.8",
              zIndex: "10",
            }}
          ></div>
          <div
            className="mainbox"
            style={{ zIndex: "60", position: "relative" }}
          >
            <div className="container d-flex justify-content-center">
              <div className="banner-content px-lg-5  d-flex flex-column justify-content-center text-center text-white">
                <h2 className="font-face-rb">
                  Explore Our Outdoor Living Solutions
                </h2>
                <p className="px-lg-5 px-2 ">
                  Discover a range of beautifully crafted outdoor enhancements
                  from elegant pergolas and glass rooms to functional BBQ
                  counters and CNC cut panels. Each product is designed to
                  elevate your lifestyle with durability, style, and seamless
                  integration.
                </p>
              </div>
            </div>

            <div className="w-100 d-flex justify-content-center">
              <div class="row d-flex justify-content-center align-ietms-center mb-5 p-0 mt-3 px-3 px-md-5 w-100">
                <div
                  class="col-lg-12 p-0 col-md-12"
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{ cursor: "pointer" }}
                >
                  <Slider {...settings} ref={sliderRef}>
                    {items.map((x, index) => {
                      return (
                        <>
                          <div
                            className="px-2 "
                            key={index}
                            ref={(el) => (slideRefs.current[index] = el)}
                          >
                            <div className="testimonialscard  m-0 row h-100">
                              <div className="col-sm-4 col-12 p-0 m-0">
                                <div className="h-100 w-100 img-div">
                                  <img
                                    src={x.img}
                                    className="img-fluid"
                                    loading="lazy"
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-sm-8 d-flex flex-column justify-content-center">
                                <div className="py-3 px-4">
                                  <h5 className="font-face-rb">{x.heading}</h5>
                                  <p className="font-face-rr text-black p-0 m-0">
                                    {x.description}
                                  </p>
                                  <a
                                    className="readmore-link mt-3"
                                    onClick={() => navigate(x.route)}
                                  >
                                    <BsFillPlusCircleFill />
                                    <span className="pt-5">READ MORE</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div className="bgbanner">
          <div className="container profile-page py-5">
          <div className="row d-flex justify-content-center align-items-center">
            {cardsData?.map((card) => (
              <div
                className="col-md-6 col-xl-4"
                key={card.id}
                data-aos="flip-left"
                data-aos-duration="1000"
              >
                <div className="card-one mb-4 d-flex flex-column gap-3">
                  <div>
                    <img
                      src={card.imgSrc}
                      className="img-fluid"
                      style={{ width: "45px" }}
                      loading="lazy"
                    />
                  </div>
                  <div className="card-body">
                    <h5 className="card-title font-face-rr">{card.title}</h5>
                    <p className="card-text mt-2 font-face-rr">
                      {card.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default WorkFlow;
